<mm-dialog-title>
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_INSTRUCTIONS' | translate }}
</mm-dialog-title>

<mm-dialog-content>
    <div class="return-instructions-container"
         [innerHTML]="'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_INSTRUCTIONS.TEXT' | translate :
         { linkToFAQs: linkToFAQs }"></div>
</mm-dialog-content>
